import { Text } from "@chakra-ui/react";

const HeaderCell = ({ label }) => {
  return (
    <Text
      textAlign="left"
      fontSize="16px"
      lineHeight="20px"
      fontFamily="PlusJakartaSansMedium"
      textTransform="capitalize"
      color="#898989"
    >
      {label}
    </Text>
  );
};

export default HeaderCell;
